// GoogleTranslateLoader.js
import { useEffect } from "react";

let initialized = false;

const GoogleTranslateLoader = () => {
  useEffect(() => {
    if (!initialized) {
      const script = document.createElement("script");
      script.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      document.body.appendChild(script);

      // This function is needed globally to be called by Google
      window.googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages: "en,es",
            autoDisplay: false,
          },
          // Only initialize if the element exists
          "google_translate_element"
        );
      };

      initialized = true;
    }
  }, []);

  return null; // No UI
};

export default GoogleTranslateLoader;
